<ms-progress-bar
    [shouldShowInformation]="shouldShowInformation"
    [shouldShowPercentage]="shouldShowPercentage"
    [informationText]="informationText"
    [smoothProgressTransition]="smoothProgressTransition"
    [animationDuration]="animationDuration"
    [value]="value$" />
